import "./Spinner.css";

const Spinner = ({description = "Loading please wait..."}) => {
  return (
    <section>
      <div className="loader"></div>
      <p className="text">{description}</p>
    </section>
  );
};

export default Spinner;
